import React, { useEffect, useState } from "react";
import Logo from "../../../assets/images/InternationalAcademy/logo.png";
import { useLocation } from "react-router-dom";
const AboutContent = () => {
  const location =useLocation();
  const [currentSection, setSection] = useState("all");
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      setSection(hash)
    } else {
      setSection("all")
    }
  }, [location]);

  return (
    <div className="my-24 flex items-center flex-col gap-3">
      <img src={Logo} className="w-60" alt="" />
      <h2 className="text-xl md:text-3xl">International Academy Myanmar</h2>
      <div className="lg:w-3/4 px-5 mt-10 flex flex-col gap-5">
        {(currentSection === "all" || currentSection === "#vision") && <div id="vision">
          <h2 className="font-semibold text-lg py-4">Vision</h2>
          <p>Empowering our students through Excellence in Education</p>
        </div>
        }
        {
          (currentSection === "all" || currentSection === "#mission") &&
          < div id="mission">
            <h2 className="font-semibold text-lg py-4">Mission</h2>
            <p>
              {" "}
              At International Academy Myanmar, our mission is to provide a
              transformative educational experience that nurtures the holistic
              development of students, preparing them to thrive in an
              interconnected world. We are dedicated to
            </p>
          </div>
        }

        {
          (currentSection === "all" || currentSection === "#core") &&
          <section id="core">
            <h2 className="font-semibold text-lg py-4">Core Values</h2>
            <ul>
              <li>
                <strong>Academic Excellence:</strong> We strive to offer a
                rigorous and internationally recognized curriculum that fosters
                critical thinking, creativity, and a love for learning. Our
                dedicated educators inspire intellectual curiosity and empower
                students to achieve their fullest potential.
              </li>
              <li>
                <strong>Cultural Diversity:</strong> We celebrate and embrace the
                rich tapestry of cultures represented within our school community.
                Through a diverse and inclusive environment, we cultivate
                global-mindedness, cross-cultural understanding, and empathy,
                enabling our students to become respectful and open-minded global
                citizens.
              </li>
              <li>
                <strong>Character Formation: :</strong> We are committed to
                developing well-rounded individuals with strong moral character,
                integrity, and a sense of social responsibility. Our emphasis on
                values and ethics equips students with the tools to make ethical
                decisions and positively impact their communities.
              </li>
              <li>
                <strong>Innovation and Technology:</strong> We leverage the power
                of technology and innovative teaching methodologies to enhance
                learning experiences and prepare students for the dynamic
                challenges of the modern world. By nurturing adaptability and
                digital literacy, we equip our students to excel in a rapidly
                evolving global landscape.
              </li>
              <li>
                <strong>Collaborative Learning:</strong> We foster a collaborative
                learning environment that encourages teamwork, communication, and
                problem-solving skills. Through group projects, interactive
                discussions, and extracurricular activities, we empower students
                to work together effectively and respect diverse perspectives.
              </li>
              <li>
                <strong>Sustainability and Environmental Stewardship:</strong> We
                instill a sense of responsibility for the environment and promote
                sustainable practices. Through education and initiatives, we
                inspire students to become advocates for a greener and more
                sustainable future.
              </li>
              <li>
                <strong>Parent and Community Engagement: </strong> We recognize
                the importance of strong partnerships between the school, parents,
                and the broader community. By involving parents and local
                organizations in our educational journey, we create a supportive
                network that enhances the overall learning experience.
              </li>
              <li>
                <strong>Lifelong Learning: </strong> We believe that learning is a
                lifelong journey. Our students develop a growth mindset that
                encourages continuous self-improvement and a thirst for knowledge,
                ensuring they remain adaptable and resilient in a dynamic global
                landscape.
              </li>
            </ul>
          </section>
        }


      </div>
    </div >
  );
};

export default AboutContent;

// VISION AND MISSION FOR I.A.M
// Vision: Empowering our students through Excellence in Education
// Mission: At International Academy Myanmar, our mission is to provide a transformative
// educational experience that nurtures the holistic development of students, preparing them to
// thrive in an interconnected world. We are dedicated to:
// 1. Academic Excellence: We strive to offer a rigorous and internationally recognized
// curriculum that fosters critical thinking, creativity, and a love for learning. Our
// dedicated educators inspire intellectual curiosity and empower students to achieve
// their fullest potential.
// 2. Cultural Diversity: We celebrate and embrace the rich tapestry of cultures
// represented within our school community. Through a diverse and inclusive
// environment, we cultivate global-mindedness, cross-cultural understanding, and
// empathy, enabling our students to become respectful and open-minded global citizens.
// 3. Character Formation: We are committed to developing well-rounded individuals
// with strong moral character, integrity, and a sense of social responsibility. Our
// emphasis on values and ethics equips students with the tools to make ethical decisions
// and positively impact their communities.
// 4. Innovation and Technology: We leverage the power of technology and innovative
// teaching methodologies to enhance learning experiences and prepare students for the
// dynamic challenges of the modern world. By nurturing adaptability and digital
// literacy, we equip our students to excel in a rapidly evolving global landscape.
// 5. Collaborative Learning: We foster a collaborative learning environment that
// encourages teamwork, communication, and problem-solving skills. Through group
// projects, interactive discussions, and extracurricular activities, we empower students
// to work together effectively and respect diverse perspectives.
// 6. Sustainability and Environmental Stewardship: We instill a sense of responsibility
// for the environment and promote sustainable practices. Through education and
// initiatives, we inspire students to become advocates for a greener and more
// sustainable future.
// 7. Parent and Community Engagement: We recognize the importance of strong
// partnerships between the school, parents, and the broader community. By involving
// parents and local organizations in our educational journey, we create a supportive
// network that enhances the overall learning experience.
// 8. Lifelong Learning: We believe that learning is a lifelong journey. Our students
// develop a growth mindset that encourages continuous self-improvement and a thirst
// for knowledge, ensuring they remain adaptable and resilient in a dynamic global
// landscape.
// Through our unwavering commitment to these principles, IAM aspires to produce graduates
// who are not only academically proficient but also socially responsible, culturally aware, and
// equipped to make meaningful contributions to a global society.
